module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Landing-page.e0bd68c3.jpg";